import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class metadataListService {
  // 获取列表
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataListings?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 导出
  static async exportMetadataList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/MetaDataListings/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 获取链式图数据
  static async getGraphData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/MetaDataListings/get_fullchainanalysis?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
}
